
import KeyenceHTHardKeyButton from '@/components/keyenceHT/hardkeys/KeyenceHTHardKeyButton.vue'
import { Options, Vue } from 'vue-class-component'
import { Prop, PropSync } from 'vue-property-decorator'
import { KeyenceHardKey } from '@/utils/keyenceHT/keyenceHardKeyEventHandler'
import { isKeyenceEnterpriseBrowser } from '@/utils/keyenceHT/keyenceModules'

@Options({
  components: {
    KeyenceHTHardKeyButton,
  },
  emits: ['update:isShow'],
  name: 'ReviewCalculationDialog',
})
export default class ReviewCalculationDialog extends Vue {
  @PropSync('isShow', { type: Boolean }) _isShow!: boolean
  @Prop({ type: String }) readonly content?: string

  KeyenceHardKey = KeyenceHardKey

  get isKeyenceEnterpriseBrowser(): boolean {
    return isKeyenceEnterpriseBrowser()
  }

  closeDialog() {
    this._isShow = false
  }
}
